import React, { Fragment, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ChangePasswordModalAdmin from '../ChangePasswordModalAdmin/ChangePasswordModalAdmin.jsx';
import UpdateBranch from '../UpdateBranch/UpdateBranch.jsx';
import { BranchContext } from '../../../Context/BranchContext.js';



export default function SpecificBranch() {
   const{id} = useParams () ;
   const {getSpecificBranch , deleteBranch , branch } = useContext(BranchContext) ;



   useEffect(() => {
      getSpecificBranch(id)
   }, [])
   
   return (
      <Fragment>
         <div className="container mt-5">
            <h1 className='main-header'>Specific branch</h1>
            <div className='under-header'></div>

            <div className="row ">
               <div className="col-md-12 mb-4">
                  <h4 className='fw-bold'>branch Information :</h4>
                  <div className='border border-1 p-2 rounded-2'>

                     <table className="table table-sm table-striped">

                        <tbody>
                           <tr>
                              <th scope="row">Name :</th>
                              <td>{branch.name}</td>
                           </tr>
                           <tr>
                              <th scope="row">Phone:</th>
                              <td>{branch.phone}</td>
                           </tr>
                           <tr>
                              <th scope="row">Email:</th>
                              <td>{branch.email}</td>
                           </tr>
                           <tr>
                              <th scope="row">Company:</th>
                              <td>{branch.company?.name}</td>
                           </tr>
                           <tr>
                              <th scope="row">Address:</th>
                              <td>Street: <span className='fw-bold d-inline-block me-5'>{branch.address?.street}</span>    City:<span className='fw-bold d-inline-block me-5'>{branch.address?.city}</span>     Area:<span className='fw-bold d-inline-block'>{branch.address?.area}</span></td>
                           </tr>
                           <tr>
                              <th scope="row">State:</th>
                              <td>{branch.isActive? <p className='text-success'>Active branch</p> : <p className='text-danger'>Not Active branch</p>}</td>
                           </tr>
                           <tr>
                              <th scope="row">Created By :</th>
                              <td>{branch.createdBy?.name}</td>
                           </tr>

                        </tbody>
                     </table>

                     <div className='text-center'>
                        <button onClick={()=>{deleteBranch(id)}}  className='btn btn-sm btn-outline-danger'>Delete branch <i className="fa-solid fa-trash px-2"></i></button>
                        <button className="btn btn-outline-primary btn-sm d-inline-block mx-2" data-bs-toggle="modal" data-bs-target="#ChangePasswordModalAdmin">Change Password <i class="fa-solid fa-unlock-keyhole ms-2"></i></button>
                        <button className="btn btn-outline-primary btn-sm d-inline-block" data-bs-toggle="modal" data-bs-target="#UpdateBranch">Update branch  <i className="fa-solid fa-pen ms-2"></i></button>
                     </div>

                     <ChangePasswordModalAdmin id={id} />
                     <UpdateBranch/>
                     
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   )
}
